module.exports = __webpack_public_path__ + "img/CW.717a4a31.png";